import { NotificationsUiModuleBody, NotificationsUiModuleBodyModuleTypeEnum } from '../../../API';
import generateId from '../../../utils/generateId';
import { NewModuleFunction } from '../../../utils/layouts';

export const blankNotificationsModule: NewModuleFunction<NotificationsUiModuleBody> = (module) => ({
  moduleType: NotificationsUiModuleBodyModuleTypeEnum.NOTIFICATIONS,
  moduleId: generateId(),
  // @ts-expect-error - header is required but starts empty
  header: undefined,
  ...module
});
